import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import Header from "./components/Header";
import LocationsList from "./components/LocationsList";
import ProductList from "./components/ProductList";
import WarehouseList from "./components/WarehouseList";
import AddProductForm from "./components/AddProductForm";
import SoldProductsList from './components/SoldProductsList';
// import OrdersExport from './components/OrdersExport';
import PublicProductList from './components/PublicProductList';
import Login from "./components/Login";
import DevPanel from "./components/DevPanel";
import { BASE_URL } from "./config";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

function AppContent() {
    const [searchQuery, setSearchQuery] = useState("");
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();

    const checkAuthStatus = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/check-auth`, {
                credentials: 'include'
            });
            setIsAuthenticated(response.ok);
        } catch (error) {
            setIsAuthenticated(false);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // Only check auth if we're not on a public/dev page
        if (!location.pathname.startsWith('/public') && location.pathname !== '/dev') {
            checkAuthStatus();
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const handleLogin = () => {
        setIsAuthenticated(true);
    };

    const handleLogout = async () => {
        try {
            await fetch(`${BASE_URL}/api/logout`, {
                method: 'POST',
                credentials: 'include'
            });
            setIsAuthenticated(false);
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    // Don't show loading screen for public/dev pages
    if (isLoading && !location.pathname.startsWith('/public') && location.pathname !== '/dev') {
        return (
            <div className="app-loading-screen">
                <div className="app-spinner" />
            </div>
        );
    }

    return (
        <>
            {isAuthenticated && (
                <Header 
                    searchQuery={searchQuery} 
                    setSearchQuery={setSearchQuery} 
                    onLogout={handleLogout}
                />
            )}

            <Routes>
                {/* Public route - accessible without authentication */}
                <Route
                    path="/public/products"
                    element={<PublicProductList />}
                />

                {/* Dev panel - own password protection */}
                <Route path="/dev" element={<DevPanel />} />

                <Route 
                    path="/login" 
                    element={
                        isAuthenticated ? (
                            <Navigate to="/" replace />
                        ) : (
                            <Login onLogin={handleLogin} />
                        )
                    } 
                />
                
                <Route 
                    path="/" 
                    element={
                        isAuthenticated ? (
                            <ProductList searchQuery={searchQuery} />
                        ) : (
                            <Navigate to="/login" replace />
                        )
                    } 
                />
                
                <Route 
                    path="/locations" 
                    element={
                        isAuthenticated ? (
                            <LocationsList />
                        ) : (
                            <Navigate to="/login" replace />
                        )
                    } 
                />
                
                <Route 
                    path="/add-product" 
                    element={
                        isAuthenticated ? (
                            <AddProductForm />
                        ) : (
                            <Navigate to="/login" replace />
                        )
                    } 
                />
                
                <Route 
                    path="/warehouses" 
                    element={
                        isAuthenticated ? (
                            <WarehouseList />
                        ) : (
                            <Navigate to="/login" replace />
                        )
                    } 
                />

                <Route 
                    path="/sold-products" 
                    element={
                        isAuthenticated ? (
                            <SoldProductsList />
                        ) : (
                            <Navigate to="/login" replace />
                        )
                    } 
                />

                {/*
                <Route
                    path="/orders"
                    element={
                        isAuthenticated ? (
                            <OrdersExport />
                        ) : (
                            <Navigate to="/login" replace />
                        )
                    }
                />
                */}


            </Routes>
        </>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;
